import React from 'react';

import TextField from '@mui/material/TextField';

type Props = {
  label: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  type?: 'text' | 'password';
  helperText?: string;
  value?: string;
  fullWidth?: boolean;
};

/**
 * ガイド画面で表示用のモックテキストフィールド（操作不能）
 */
const GuideMockTextField: React.FC<Props> = ({
  label,
  required = false,
  placeholder,
  disabled = false,
  type = 'text',
  helperText,
  value = '',
  fullWidth = true,
}) => {
  return (
    <TextField
      size="small"
      label={label}
      required={required}
      placeholder={placeholder}
      disabled={disabled}
      type={type}
      helperText={helperText}
      value={value}
      fullWidth={fullWidth}
      sx={{
        pointerEvents: 'none',
        '& .MuiOutlinedInput-root': { borderRadius: 2 },
      }}
    />
  );
};

export default GuideMockTextField;
